// // import { Outlet, NavLink, Link } from "react-router-dom";
// // import {
// //   Layers, LayoutGrid, FolderKanban, PlusCircle, Compass, Cpu, Users,
// //   Calendar, FileText, ShoppingCart, CreditCard, File, MessageSquare,
// //   HelpCircle, ChevronDown, Search, Bell,
// // } from "lucide-react";

// // const discoverLinks = [
// //   { to: "/app/facilities", label: "Facilities", icon: Compass },
// //   { to: "/app/machines", label: "Machines", icon: Cpu },
// //   { to: "/app/experts", label: "Experts", icon: Users },
// // ];

// // const manageLinks = [
// //   // { to: "/app/bookings", label: "Bookings", icon: Calendar },
// //   { to: "/app/quotations", label: "Quotations", icon: FileText, badge: 2 },
// //   { to: "/app/orders", label: "Orders", icon: ShoppingCart },
// //   { to: "/app/payments", label: "Payments", icon: CreditCard },
// //   { to: "/app/documents", label: "Documents", icon: File },
// // ];

// // const supportLinks = [
// //   { to: "/app/messages", label: "Messages", icon: MessageSquare, badge: 3 },
// //   { to: "/app/help", label: "Help & Support", icon: HelpCircle },
// // ];

// // function NavItem({ to, label, icon: Icon, badge }) {
// //   return (
// //     <NavLink
// //       to={to}
// //       className={({ isActive }) =>
// //         `flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition ${
// //           isActive
// //             ? "bg-indigo-600 text-white"
// //             : "text-indigo-100/80 hover:bg-white/5 hover:text-white"
// //         }`
// //       }
// //     >
// //       <span className="flex items-center gap-3">
// //         <Icon className="w-4 h-4" />
// //         {label}
// //       </span>
// //       {badge != null && (
// //         <span className="text-[11px] font-semibold bg-white/15 text-white px-1.5 py-0.5 rounded-md">
// //           {badge}
// //         </span>
// //       )}
// //     </NavLink>
// //   );
// // }

// // function SectionLabel({ children }) {
// //   return (
// //     <p className="text-[11px] font-semibold text-indigo-300/60 tracking-wider px-3 mt-6 mb-2">
// //       {children}
// //     </p>
// //   );
// // }

// // export default function UserLayout() {
// //   return (
// //     <div className="flex min-h-screen bg-gray-50">
// //       {/* Sidebar */}
// //       <aside style={{maxHeight:"90vh", overflow:"auto", scrollbarWidth:"none"}} className="w-72 shrink-0 bg-[#0f1229] text-white min-h-screen flex flex-col px-4 py-6">
// //         <div className="flex items-center gap-3 px-2 mb-6">
// //           <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
// //             <Layers className="text-white w-4 h-4" />
// //           </div>
// //           <div>
// //             <p className="font-bold leading-tight">
// //               APIC <span className="text-indigo-300">ProtoHub</span>
// //             </p>
// //             <p className="text-[10px] tracking-wide text-indigo-300/60 leading-tight">
// //               ANDHRA PRADESH
// //             </p>
// //           </div>
// //         </div>

// //         <button className="flex items-center justify-between bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold rounded-xl px-4 py-2.5 mb-4">
// //           Innovator Workspace
// //           <ChevronDown className="w-4 h-4" />
// //         </button>

// //         <nav className="flex flex-col gap-1">
// //           <NavItem to="/app/dashboard" label="Dashboard" icon={LayoutGrid} />
// //           <NavItem to="/app/projects" label="My Projects" icon={FolderKanban} badge={6} />
// //           <NavItem to="/app/new-prototype" label="New Prototype" icon={PlusCircle} />
// //         </nav>

// //         {/* <SectionLabel>DISCOVER</SectionLabel> */}
// //         <nav className="flex flex-col gap-1">
// //           {discoverLinks.map((l) => (
// //             <NavItem key={l.to} {...l} />
// //           ))}
// //         </nav>

// //         {/* <SectionLabel>MANAGE</SectionLabel> */}
// //         <nav className="flex flex-col gap-1">
// //           {manageLinks.map((l) => (
// //             <NavItem key={l.to} {...l} />
// //           ))}
// //         </nav>

// //         {/* <SectionLabel>SUPPORT</SectionLabel> */}
// //         <nav className="flex flex-col gap-1">
// //           {supportLinks.map((l) => (
// //             <NavItem key={l.to} {...l} />
// //           ))}
// //         </nav>
// //       </aside>

// //       {/* Right side: Topbar + page content */}
// //       <div className="flex-1 flex flex-col min-w-0">
// //         <header className="h-[73px] shrink-0 border-b border-gray-100 bg-white flex items-center justify-between px-6 gap-4">
// //           <div className="flex items-center gap-2 flex-1 max-w-md bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
// //             <Search className="w-4 h-4 text-gray-400" />
// //             <input
// //               placeholder="Search projects, machines, centres..."
// //               className="w-full bg-transparent text-sm focus:outline-none"
// //             />
// //           </div>

// //           <div className="flex items-center gap-4">
// //             <Link
// //               to="/app/new-prototype"
// //               className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold px-4 py-2.5 rounded-xl transition"
// //             >
// //               <PlusCircle className="w-4 h-4" />
// //               New Prototype
// //             </Link>

// //             <button className="text-gray-500 hover:text-gray-700">
// //               <HelpCircle className="w-5 h-5" />
// //             </button>

// //             <button className="relative text-gray-500 hover:text-gray-700">
// //               <Bell className="w-5 h-5" />
// //               <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-pink-500" />
// //             </button>

// //             <div className="w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xs font-bold flex items-center justify-center">
// //               AR
// //             </div>
// //           </div>
// //         </header>

// //         <main style={{maxHeight:"90vh", overflow:"auto", scrollbarWidth:"none",backgroundColor:"white"}} className="flex-1 p-6">
// //           <Outlet />
// //         </main>
// //       </div>
// //     </div>
// //   );
// // }



// import { useState } from "react";
// import { Outlet, NavLink, Link } from "react-router-dom";
// import {
//   Layers, LayoutGrid, FolderKanban, PlusCircle, Compass, Cpu, Users,
//   Calendar, FileText, ShoppingCart, CreditCard, File, MessageSquare,
//   HelpCircle, ChevronDown, Search, Bell, Menu, X,
// } from "lucide-react";

// const discoverLinks = [
//   { to: "/app/facilities", label: "Facilities", icon: Compass },
//   // { to: "/app/machines", label: "Machines", icon: Cpu },
//   { to: "/app/experts", label: "Experts", icon: Users },
// ];

// const manageLinks = [
//   { to: "/app/quotations", label: "Quotations", icon: FileText, badge: 2 },
//   { to: "/app/orders", label: "Orders", icon: ShoppingCart },
//   // { to: "/app/payments", label: "Payments", icon: CreditCard },
//   // { to: "/app/documents", label: "Documents", icon: File },
// ];

// const supportLinks = [
//   // { to: "/app/messages", label: "Messages", icon: MessageSquare, badge: 3 },
//   { to: "/app/help", label: "Help & Support", icon: HelpCircle },
// ];

// function NavItem({ to, label, icon: Icon, badge, onClick }) {
//   return (
//     <NavLink
//       to={to}
//       onClick={onClick}
//       className={({ isActive }) =>
//         `flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition ${
//           isActive
//             ? "bg-indigo-600 text-white"
//             : "text-indigo-100/80 hover:bg-white/5 hover:text-white"
//         }`
//       }
//     >
//       <span className="flex items-center gap-3">
//         <Icon className="w-4 h-4 shrink-0" />
//         <span className="truncate">{label}</span>
//       </span>
//       {badge != null && (
//         <span className="text-[11px] font-semibold bg-white/15 text-white px-1.5 py-0.5 rounded-md shrink-0">
//           {badge}
//         </span>
//       )}
//     </NavLink>
//   );
// }

// function SectionLabel({ children }) {
//   return (
//     <p className="text-[11px] font-semibold text-indigo-300/60 tracking-wider px-3 mt-6 mb-2">
//       {children}
//     </p>
//   );
// }

// export default function UserLayout() {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
//   const closeSidebar = () => setIsSidebarOpen(false);

//   return (
//     <div className="flex min-h-screen bg-gray-50">
//       {/* Mobile overlay */}
//       {isSidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40 lg:hidden"
//           onClick={closeSidebar}
//         />
//       )}

//       {/* Sidebar */}
//       <aside
//         className={`
//           fixed lg:sticky top-0 z-50 
//           w-72 max-w-[80vw] h-screen
//           bg-[#0f1229] text-white 
//           flex flex-col px-4 py-6
//           transition-transform duration-300 ease-in-out
//           ${isSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
//         `}
//         style={{ maxHeight: "100vh", overflow: "auto", scrollbarWidth: "none" }}
//       >
//         {/* Close button - mobile only */}
//         <button
//           onClick={closeSidebar}
//           className="lg:hidden absolute top-4 right-4 text-white/60 hover:text-white"
//         >
//           <X className="w-6 h-6" />
//         </button>

//         <div className="flex items-center gap-3 px-2 mb-6">
//           <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
//             <Layers className="text-white w-4 h-4" />
//           </div>
//           <div className="min-w-0">
//             <p className="font-bold leading-tight truncate">
//               APIC <span className="text-indigo-300">ProtoHub</span>
//             </p>
//             <p className="text-[10px] tracking-wide text-indigo-300/60 leading-tight truncate">
//               ANDHRA PRADESH
//             </p>
//           </div>
//         </div>

//         <button className="flex items-center justify-between bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold rounded-xl px-4 py-2.5 mb-4">
//           <span className="truncate">Innovator Workspace</span>
//           <ChevronDown className="w-4 h-4 shrink-0 ml-2" />
//         </button>

//         <nav className="flex flex-col gap-1">
//           <NavItem to="/app/dashboard" label="Dashboard" icon={LayoutGrid} onClick={closeSidebar} />
//           <NavItem to="/app/projects" label="My Projects" icon={FolderKanban} badge={6} onClick={closeSidebar} />
//           <NavItem to="/app/new-prototype" label="New Prototype" icon={PlusCircle} onClick={closeSidebar} />
//         </nav>

//         <nav className="flex flex-col gap-1">
//           {discoverLinks.map((l) => (
//             <NavItem key={l.to} {...l} onClick={closeSidebar} />
//           ))}
//         </nav>

//         <nav className="flex flex-col gap-1">
//           {manageLinks.map((l) => (
//             <NavItem key={l.to} {...l} onClick={closeSidebar} />
//           ))}
//         </nav>

//         <nav className="flex flex-col gap-1">
//           {supportLinks.map((l) => (
//             <NavItem key={l.to} {...l} onClick={closeSidebar} />
//           ))}
//         </nav>
//       </aside>

//       {/* Right side: Topbar + page content */}
//       <div className="flex-1 flex flex-col min-w-0">
//         <header className="h-[73px] shrink-0 border-b border-gray-100 bg-white flex items-center justify-between px-3 sm:px-6 gap-2 sm:gap-4">
//           {/* Mobile menu button */}
//           <button
//             onClick={toggleSidebar}
//             className="lg:hidden p-2 -ml-2 text-gray-600 hover:text-gray-900"
//           >
//             <Menu className="w-6 h-6" />
//           </button>

//           {/* Search - hidden on mobile, visible on larger screens */}
//           <div className="hidden sm:flex items-center gap-2 flex-1 max-w-md bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
//             <Search className="w-4 h-4 text-gray-400 shrink-0" />
//             <input
//               placeholder="Search projects, machines, centres..."
//               className="w-full bg-transparent text-sm focus:outline-none min-w-0"
//             />
//           </div>

//           {/* Mobile search icon */}
//           <button className="sm:hidden text-gray-500 hover:text-gray-700">
//             <Search className="w-5 h-5" />
//           </button>

//           <div className="flex items-center gap-2 sm:gap-4 ml-auto">
//             {/* New Prototype - hide text on mobile */}
//             <Link
//               to="/app/new-prototype"
//               className="hidden sm:flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold px-3 sm:px-4 py-2.5 rounded-xl transition whitespace-nowrap"
//             >
//               <PlusCircle className="w-4 h-4 shrink-0" />
//               <span className="hidden sm:inline">New Prototype</span>
//               <span className="sm:hidden">New</span>
//             </Link>

//             <button className="text-gray-500 hover:text-gray-700 hidden sm:block">
//               <HelpCircle className="w-5 h-5" />
//             </button>

//             <button className="relative text-gray-500 hover:text-gray-700">
//               <Bell className="w-5 h-5" />
//               <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-pink-500" />
//             </button>

//             <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xs font-bold flex items-center justify-center shrink-0">
//               AR
//             </div>
//           </div>
//         </header>

//         <main 
//           className="flex-1 p-3 sm:p-4 md:p-6 bg-white"
//           style={{ maxHeight: "calc(100vh - 73px)", overflow: "auto", scrollbarWidth: "none" }}
//         >
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// }



import { useState, useRef, useEffect } from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import {
  Layers, LayoutGrid, FolderKanban, PlusCircle, Compass, Cpu, Users,
  Calendar, FileText, ShoppingCart, CreditCard, File, MessageSquare,
  HelpCircle, ChevronDown, Search, Bell, Menu, X, ChevronLeft,
  LogOut, User, Settings, ChevronRight, BadgePercent, AlignJustify,
  Inbox
} from "lucide-react";

const discoverLinks = [
  { to: "/app/facilities", label: "Facilities", icon: Compass },
  // { to: "/app/machines", label: "Machines", icon: Cpu },
  { to: "/app/experts", label: "Experts", icon: Users },
];

const manageLinks = [
  { to: "/app/quotations", label: "Quotations", icon: FileText, badge: 2 },
  { to: "/app/orders", label: "Orders", icon: ShoppingCart },
  // { to: "/app/promotions", label: "Promotions", icon: BadgePercent },
  { to: "/app/payments", label: "Payments", icon: CreditCard },
  // { to: "/app/documents", label: "Documents", icon: File },
];

const supportLinks = [
  // { to: "/app/messages", label: "Messages", icon: MessageSquare, badge: 3 },
  { to: "/app/help", label: "Help & Support", icon: HelpCircle },
];

function NavItem({ to, label, icon: Icon, badge, onClick, isCollapsed }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        `flex items-center justify-between px-3 py-2.5 rounded-xl text-sm font-medium transition ${isActive
          ? "bg-indigo-600 text-white"
          : "text-indigo-100/80 hover:bg-white/5 hover:text-white"
        } ${isCollapsed ? "justify-center px-2" : ""}`
      }
      title={isCollapsed ? label : ""}
    >
      <span className={`flex items-center gap-3 ${isCollapsed ? "justify-center" : ""}`}>
        <Icon className="w-5 h-5 shrink-0" />
        {!isCollapsed && <span className="truncate">{label}</span>}
      </span>
      {!isCollapsed && badge != null && (
        <span className="text-[11px] font-semibold bg-white/15 text-white px-1.5 py-0.5 rounded-md shrink-0">
          {badge}
        </span>
      )}
    </NavLink>
  );
}

function SectionLabel({ children, isCollapsed }) {
  if (isCollapsed) return null;
  return (
    <p className="text-[11px] font-semibold text-indigo-300/60 tracking-wider px-3 mt-6 mb-2">
      {children}
    </p>
  );
}

export default function UserLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const navigate = useNavigate();
  const profileRef = useRef(null);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleCollapse = () => setIsCollapsed(!isCollapsed);
  const toggleProfile = () => setIsProfileOpen(!isProfileOpen);
  const closeProfile = () => setIsProfileOpen(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        closeProfile();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    closeProfile();
    navigate("/");
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:sticky top-0 z-50 
          h-screen
          bg-[#0f1229] text-white 
          flex flex-col px-4 py-6
          transition-all duration-300 ease-in-out
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
          ${isCollapsed ? "w-20" : "w-50"}
        `}
        style={{ maxHeight: "100vh", overflow: "auto", scrollbarWidth: "none",backgroundColor:"#0c1c45" }}
      >
        {/* Close button - mobile only */}
        <button
          onClick={closeSidebar}
          className="lg:hidden absolute top-4 right-4 text-white/60 hover:text-white"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Logo and Toggle Button */}
        {/* Logo and Toggle Button */}
        <div className={`flex items-center gap-3 px-2 mb-6 ${isCollapsed ? "justify-center" : ""}`}>
          {/* Hide toggle button on mobile when sidebar is open */}
          <button
            onClick={toggleCollapse}
            className={`p-1 hover:bg-white/10 rounded-lg transition text-indigo-300/60 hover:text-white shrink-0 ${isSidebarOpen ? "hidden lg:block" : "block"
              }`}
            title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <AlignJustify className="w-5 h-5" />
          </button>

          {!isCollapsed && (
            <>
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
                <Layers className="text-white w-4 h-4" />
              </div>
              <div className="min-w-0">
                <p className="font-bold leading-tight truncate">
                  APIC <span className="text-indigo-300">ProtoHub</span>
                </p>
                <p className="text-[10px] tracking-wide text-indigo-300/60 leading-tight truncate">
                  ANDHRA PRADESH
                </p>
              </div>
            </>
          )}

          {/* {isCollapsed && !isSidebarOpen && (
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shrink-0">
              <Layers className="text-white w-4 h-4" />
            </div>
          )} */}
        </div>


        <nav className="flex flex-col gap-1">
          <NavItem
            to="/app/dashboard"
            label="Dashboard"
            icon={LayoutGrid}
            onClick={closeSidebar}
            isCollapsed={isCollapsed}
          />
          <NavItem
            to="/app/my-enquiries"
            label="My Enquiries"
            icon={Inbox}
            onClick={closeSidebar}
            isCollapsed={isCollapsed}
          />

          <NavItem
            to="/app/projects"
            label="My Projects"
            icon={FolderKanban}
            badge={6}
            onClick={closeSidebar}
            isCollapsed={isCollapsed}
          />


          <NavItem
            to="/app/new-prototype"
            label="New Prototype"
            icon={PlusCircle}
            onClick={closeSidebar}
            isCollapsed={isCollapsed}
          />
        </nav>

        <nav className="flex flex-col gap-1">
          {discoverLinks.map((l) => (
            <NavItem key={l.to} {...l} onClick={closeSidebar} isCollapsed={isCollapsed} />
          ))}
        </nav>

        <nav className="flex flex-col gap-1">
          {manageLinks.map((l) => (
            <NavItem key={l.to} {...l} onClick={closeSidebar} isCollapsed={isCollapsed} />
          ))}
        </nav>

        <nav className="flex flex-col gap-1">
          {supportLinks.map((l) => (
            <NavItem key={l.to} {...l} onClick={closeSidebar} isCollapsed={isCollapsed} />
          ))}
        </nav>
      </aside>

      {/* Right side: Topbar + page content */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-[73px] shrink-0 border-b border-gray-100 bg-white flex items-center justify-between px-3 sm:px-6 gap-2 sm:gap-4">
          {/* Mobile menu button */}
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-2 -ml-2 text-gray-600 hover:text-gray-900"
          >
            <Menu className="w-6 h-6" />
          </button>

          {/* Search */}
          <div className="hidden sm:flex items-center gap-2 flex-1 max-w-md bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5">
            <Search className="w-4 h-4 text-gray-400 shrink-0" />
            <input
              placeholder="Search projects, machines, centres..."
              className="w-full bg-transparent text-sm focus:outline-none min-w-0"
            />
          </div>

          {/* Mobile search icon */}
          <button className="sm:hidden text-gray-500 hover:text-gray-700">
            <Search className="w-5 h-5" />
          </button>

          <div className="flex items-center gap-2 sm:gap-4 ml-auto">
            <Link
              to="/app/new-prototype"
              className="hidden sm:flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold px-3 sm:px-4 py-2.5 rounded-xl transition whitespace-nowrap"
            >
              <PlusCircle className="w-4 h-4 shrink-0" />
              <span className="hidden sm:inline">New Prototype</span>
              <span className="sm:hidden">New</span>
            </Link>

            <button className="text-gray-500 hover:text-gray-700 hidden sm:block">
              <HelpCircle className="w-5 h-5" />
            </button>

            <button className="relative text-gray-500 hover:text-gray-700">
              <Bell className="w-5 h-5" />
              <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-pink-500" />
            </button>

            {/* Profile dropdown */}
            <div className="relative" ref={profileRef}>
              <button
                onClick={toggleProfile}
                className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-xs font-bold flex items-center justify-center shrink-0 hover:ring-2 hover:ring-indigo-300 transition"
              >
                AR
              </button>

              {/* Dropdown menu */}
              {isProfileOpen && (
                <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-gray-100 py-1 overflow-hidden z-50 animate-fadeIn">
                  {/* User info */}
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="font-semibold text-gray-900">A. Reddy</p>
                    <p className="text-xs text-gray-500">innovator@apic.ap.gov.in</p>
                  </div>

                  {/* Menu items */}
                  <button
                    onClick={() => {
                      closeProfile();
                      // Navigate to profile page if needed
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition"
                  >
                    <User className="w-4 h-4 text-gray-400" />
                    Profile
                    <ChevronRight className="w-4 h-4 text-gray-300 ml-auto" />
                  </button>

                  <button
                    onClick={() => {
                      closeProfile();
                      // Navigate to settings page if needed
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition"
                  >
                    <Settings className="w-4 h-4 text-gray-400" />
                    Settings
                    <ChevronRight className="w-4 h-4 text-gray-300 ml-auto" />
                  </button>

                  {/* Logout button */}
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition border-t border-gray-100"
                  >
                    <LogOut className="w-4 h-4" />
                    Logout
                    <ChevronRight className="w-4 h-4 text-red-300 ml-auto" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        <main
          className="flex-1 p-3 sm:p-4 md:p-6 bg-white"
          style={{ maxHeight: "calc(100vh - 73px)", overflow: "auto", scrollbarWidth: "none" }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}